"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefined = exports.assertNotNilOrEmpty = exports.assertTruthy = exports.assertNotNil = exports.assertNotNull = exports.assertNotUndefined = exports.isTruthy = void 0;
const isTruthy = (input) => Boolean(input);
exports.isTruthy = isTruthy;
const assertNotUndefined = (input, errorMessage) => {
    if (input === undefined) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Tried to assert that input is not undefined, but it is undefined.');
    }
    return input;
};
exports.assertNotUndefined = assertNotUndefined;
const assertNotNull = (input, errorMessage) => {
    if (input === null) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Tried to assert that input is not null, but it is null.');
    }
    return input;
};
exports.assertNotNull = assertNotNull;
const assertNotNil = (input, errorMessage) => {
    if (input === undefined) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Tried to assert that input is not nil, but it is undefined.');
    }
    if (input === null) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Tried to assert that input is not nil, but it is null.');
    }
    return input;
};
exports.assertNotNil = assertNotNil;
const assertTruthy = (input, errorMessage) => {
    if (!input) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Tried to assert that input is truthy, but it is falsy.');
    }
    return input;
};
exports.assertTruthy = assertTruthy;
function assertNotNilOrEmpty(input, customErrorMessage) {
    (0, exports.assertNotNil)(input);
    if ((input === null || input === void 0 ? void 0 : input.length) === 0) {
        throw new Error(customErrorMessage !== null && customErrorMessage !== void 0 ? customErrorMessage : 'Array is empty.');
    }
    return input;
}
exports.assertNotNilOrEmpty = assertNotNilOrEmpty;
const removeUndefined = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] === undefined ? delete obj[key] : {}));
};
exports.removeUndefined = removeUndefined;
//# sourceMappingURL=nil.js.map